import React, { Component } from "react";
import { Helmet } from "react-helmet";
import FeatherIcon from "feather-icons-react";
import axios from "axios";
import { Link } from "react-router-dom";
import Listprint from "../../Listprint";

class Report extends Component {
  state = {
    loading: true, loadError: "", students: [], yearFilter: "all", statusFilter: "all",
    columns: [
      { label: "Matricule", field: "matricule", sort: "asc", width: 105 },
      { label: "Élève", field: "student", sort: "asc", width: 230 },
      { label: "Statut", field: "status", sort: "asc", width: 105 },
      { label: "Classe", field: "classe", sort: "asc", width: 145 },
      { label: "Section", field: "section", sort: "asc", width: 120 },
      { label: "Parent / tuteur", field: "parent", sort: "asc", width: 210 },
      { label: "Année", field: "scolary_year", sort: "asc", width: 100 },
      { label: "Inscription", field: "created_at", sort: "asc", width: 115 },
    ],
  };

  componentDidMount() { this.getStudents(); }
  getStudents = async () => {
    this.setState({ loading: true, loadError: "" });
    try {
      const response = await axios.get("students");
      this.setState({ students: Array.isArray(response.data) ? response.data : [] });
    } catch (error) {
      this.setState({ loadError: "Impossible de charger le rapport des élèves." });
    } finally { this.setState({ loading: false }); }
  };

  value = (value, fallback = "Non renseigné") => value === null || value === undefined || value === "" ? fallback : value;
  getStudentName = (student) => {
    const user = student?.user || {};
    return [user.last_name, user.family_name, user.first_name].filter(Boolean).join(" ").trim();
  };
  getParentName = (student) => {
    const parent = student?.user?.user || student?.parent?.user || student?.parent;
    return parent ? [parent.last_name, parent.family_name, parent.first_name].filter(Boolean).join(" ").trim() : "";
  };
  getClassName = (student) => [student?.sectionclass?.class?.short_entitled_class, student?.sectionclass?.title].filter(Boolean).join(" ").trim();
  getYear = (student) => String(student?.year?.year || "");
  getStatus = (student) => Number(student?.status) === 1 ? "active" : Number(student?.status) === 0 ? "abandoned" : "inactive";
  formatDate = (value) => {
    const date = value ? new Date(value) : null;
    return !date || Number.isNaN(date.getTime()) ? "Non renseignée" : new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "short", year: "numeric" }).format(date);
  };
  getYears = () => [...new Set(this.state.students.map(this.getYear).filter(Boolean))].sort((a, b) => b.localeCompare(a, "fr", { numeric: true }));
  getFilteredStudents = () => this.state.students.filter((student) =>
    (this.state.yearFilter === "all" || this.getYear(student) === this.state.yearFilter) &&
    (this.state.statusFilter === "all" || this.getStatus(student) === this.state.statusFilter));

  rows = (students) => students.map((student) => {
    const status = this.getStatus(student);
    const studentName = this.getStudentName(student);
    const parentName = this.getParentName(student);
    const labels = { active: "Actif", abandoned: "Abandon", inactive: "Non actif" };
    const initials = (studentName || "Élève").split(/\s+/).slice(0, 2).map((part) => part[0]).join("").toUpperCase();
    return {
      matricule: <Link to={`/students/${student.id}`} className="ev-report-matricule">{this.value(student.matricule, "Sans matricule")}</Link>,
      student: <span className="ev-report-person"><span className="ev-report-person__avatar">{student?.user?.avatar ? <img src={student.user.avatar} alt="" /> : <i>{initials}</i>}</span><span><b>{this.value(studentName, "Élève sans nom")}</b><small>{student?.user?.email || "Coordonnées non renseignées"}</small></span></span>,
      status: <span className={`ev-report-status ev-report-status--${status}`}><i />{labels[status]}</span>,
      classe: <span className="ev-report-class"><FeatherIcon icon="book-open" size={13} />{this.value(this.getClassName(student))}</span>,
      section: this.value(student?.sectionclass?.section?.short_entitled_section),
      parent: <span className="ev-report-parent"><b>{this.value(parentName)}</b>{parentName && <small>Parent / tuteur</small>}</span>,
      scolary_year: this.value(this.getYear(student)), created_at: this.formatDate(student.createdAt),
    };
  });

  render() {
    const years = this.getYears();
    const students = this.getFilteredStudents();
    const active = this.state.students.filter((student) => this.getStatus(student) === "active").length;
    const inactive = this.state.students.length - active;
    const classes = new Set(this.state.students.map(this.getClassName).filter(Boolean)).size;
    const hasFilters = this.state.yearFilter !== "all" || this.state.statusFilter !== "all";

    return <main className="container ev-page ev-report-page">
      <Helmet><title>{process.env.REACT_APP_NAME} | Rapport des élèves</title></Helmet>
      <header className="ev-page-header ev-report-header">
        <div className="ev-page-header__content">
          <span className="ev-page-header__eyebrow"><FeatherIcon icon="bar-chart-2" size={14} />Analyse scolaire</span>
          <h1>Rapport des élèves</h1>
          <p>Consultez, filtrez et imprimez une vue consolidée des inscriptions.</p>
        </div>
        <div className="ev-page-header__actions ev-report-header__actions">
          <Link to="/manuel#reports" className="ev-button ev-button--secondary"><FeatherIcon icon="book-open" size={16} />Doc</Link>
          <label className="ev-report-year"><FeatherIcon icon="calendar" size={16} /><span><small>Année scolaire</small><select value={this.state.yearFilter} onChange={(event) => this.setState({ yearFilter: event.target.value })} aria-label="Filtrer par année scolaire"><option value="all">Toutes les années</option>{years.map((year) => <option value={year} key={year}>{year}</option>)}</select></span><FeatherIcon icon="chevron-down" size={15} /></label>
        </div>
      </header>

      <section className="ev-report-stats" aria-label="Résumé du rapport">
        <article><span><FeatherIcon icon="users" size={20} /></span><div><b>{this.state.students.length}</b><small>Élèves enregistrés</small></div></article>
        <article><span><FeatherIcon icon="user-check" size={20} /></span><div><b>{active}</b><small>Élèves actifs</small></div></article>
        <article><span><FeatherIcon icon="user-minus" size={20} /></span><div><b>{inactive}</b><small>Non actifs / abandons</small></div></article>
        <article><span><FeatherIcon icon="grid" size={20} /></span><div><b>{classes}</b><small>Sections représentées</small></div></article>
      </section>

      <section className="ev-page-section ev-report-panel">
        <div className="ev-report-panel__heading"><div><span>Registre consolidé</span><h2>Liste des élèves</h2><p>{students.length} résultat{students.length !== 1 ? "s" : ""}{hasFilters ? " selon les filtres actifs" : ""}</p></div>
          <div className="ev-report-filters" aria-label="Filtrer par statut">{[["all", "Tous"], ["active", "Actifs"], ["inactive", "Non actifs"], ["abandoned", "Abandons"]].map(([value, label]) => <button type="button" key={value} className={this.state.statusFilter === value ? "is-active" : ""} onClick={() => this.setState({ statusFilter: value })} aria-pressed={this.state.statusFilter === value}>{label}</button>)}</div>
        </div>

        {this.state.loading ? <div className="ev-report-state"><FeatherIcon className="user-search-spin" icon="loader" /></div> : this.state.loadError ?
          <div className="ev-report-state ev-report-state--error"><FeatherIcon icon="alert-circle" size={32} /><h3>Rapport indisponible</h3><p>{this.state.loadError}</p><button type="button" className="ev-button ev-button--primary ev-button--small" onClick={this.getStudents}><FeatherIcon icon="refresh-cw" size={14} />Réessayer</button></div> : students.length ?
          <div className="ev-report-list">
            <Listprint columns={this.state.columns} rows={this.rows(students)} title={`Rapport des élèves${this.state.yearFilter === "all" ? "" : ` — ${this.state.yearFilter}`}`} />
        </div> :
          <div className="ev-report-state"><FeatherIcon icon={hasFilters ? "filter" : "users"} size={32} /><h3>{hasFilters ? "Aucun résultat" : "Aucun élève enregistré"}</h3><p>{hasFilters ? "Modifiez les filtres pour afficher d’autres élèves." : "Les inscriptions apparaîtront ici dès qu’elles seront disponibles."}</p>{hasFilters && <button type="button" className="ev-button ev-button--secondary ev-button--small" onClick={() => this.setState({ yearFilter: "all", statusFilter: "all" })}>Effacer les filtres</button>}</div>}
      </section>
    </main>;
  }
}

export default Report;
